<template>
    <div>
        <div class="banner_img">
        </div>
        
        <div class="head_steps">
            <Steps :current='step'>
                <Step title="登录"></Step>
                <Step title="在线协议"></Step>
                <Step title="基本信息"></Step>
                <Step title="经营信息"></Step>
                <Step title="在线经营范围"></Step>
                <Step title="信息审核"></Step>
                <Step title="费用缴纳"></Step>
                <Step title="缴纳待审核"></Step>
                <Step title="通过审核"></Step>
            </Steps>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["step"],
        data() {
            return {
                current: 0,
            };
        },
        methods: {},
        
    };
</script>
 
<style>
    @import "./head.css";
</style>
 


// WEBPACK FOOTER //
// src/components/common/head.vue